import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "DateComponent",
  components: {},
  props: ["loading"],
  data: function data() {
    var _this = this;

    return {
      btnType: "today",
      startDate: Date.now(),
      endDate: Date.now(),
      minDate: null,
      pickOptionForStart: {
        disabledDate: function disabledDate(time) {
          if (_this.endDate) {
            return (time.getTime() > _this.endDate ? true : false) || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickOptionForEnd: {
        disabledDate: function disabledDate(time) {
          if (_this.startDate) {
            return (time.getTime() < _this.startDate ? true : false) || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      }
    };
  },
  created: function created() {},
  computed: {},
  mounted: function mounted() {},
  methods: {
    setDate: function setDate(btnType) {
      var _this2 = this;

      this.btnType = btnType;
      var obj = {
        today: "0",
        "7day": "1",
        "30day": "2",
        toyear: "3",
        lastyear: "4"
      };

      switch (btnType) {
        case "today":
          this.startDate = Date.now();
          this.endDate = Date.now();
          break;

        case "7day":
          this.startDate = Date.now() - 3600000 * 24 * 7;
          this.endDate = Date.now();
          break;

        case "30day":
          this.startDate = Date.now() - 3600000 * 24 * 30;
          this.endDate = Date.now();
          break;

        case "toyear":
          var myDate0 = new Date();
          var year0 = myDate0.getFullYear();
          var startdate0 = new Date(year0 + "-01-01");
          var enddate0 = new Date(year0 + "-12-31");
          this.startDate = startdate0.getTime();
          this.endDate = enddate0.getTime();
          break;

        case "lastyear":
          var myDate = new Date();
          var year = Number(myDate.getFullYear()) - 1;
          var startdate = new Date(year + "-01-01");
          var enddate = new Date(year + "-12-31");
          this.startDate = startdate.getTime();
          this.endDate = enddate.getTime();
          break;

        case "lastlastyear":
          var myDate1 = new Date();
          var year1 = Number(myDate1.getFullYear()) - 2;
          var startdate1 = new Date(year1 + "-01-01");
          var enddate1 = new Date(year1 + "-12-31");
          this.startDate = startdate1.getTime();
          this.endDate = enddate1.getTime();
          break;

        default:
          break;
      }

      this.$nextTick(function () {
        _this2.$emit("change", [_this2.startDate, _this2.endDate]);

        _this2.$emit("changehandle", [_this2.timestampToTime(_this2.startDate), _this2.timestampToTime(_this2.endDate)], obj[_this2.btnType]);
      });
    },
    changeValue: function changeValue(value) {
      this.btnType = "other"; // if (value && value.length) {
      //   this.$emit("change", [
      //     this.$options.filters.filterDate(this.startDate, "yyyy-MM-dd"),
      //     this.$options.filters.filterDate(this.endDate, "yyyy-MM-dd")
      //   ]);
      // }
    },
    getValue: function getValue() {
      var startDate = this.startDate || Date.now() - 86400000 * 30;
      var endDate = this.endDate || Date.now();
      endDate = this.btnType == "other" ? endDate + 86399000 : endDate;
      return [startDate, endDate];
    },
    getValueStr: function getValueStr() {
      var startDate = this.startDate || Date.now() - 86400000 * 30;
      var endDate = this.endDate || Date.now();
      endDate = this.btnType == "other" ? endDate + 86399000 : endDate;
      return [this.timestampToTime(startDate), this.timestampToTime(this.timestampToTime(endDate))];
    },
    timestampToTime: function timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear() + "-";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return Y + M + D;
    }
  }
};